<div #container (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">
    <ng-content>
    </ng-content>
</div>
<div class="dots-container" *ngIf="isNavigationAllowed && showDots">
    <div class="dot" *ngFor="let data of dots(); let i = index" [class.active]="i === activeTabIndex()"
        (click)="goToSlide(i)">
    </div>
</div>